import { FC, useEffect, useRef, useState } from 'react'

import { isFuture } from 'date-fns'

import { REQUEST_COMMENTARY_INTERVAL } from '@sportworld/js-sdk/src/constants/soccerData'
import {
  CommentaryData,
  MatchStatus,
} from '@sportworld/js-sdk/src/types/soccerDataTypes'

import { getCommentary } from '@/actions'
import { ContentUnavailable } from '@/components/ContentUnavailable/ContentUnavailable'
import { MatchCommentaryContentProps } from '@/components/DataWidget/types'
import { Loader } from '@/components/Loader'
import { commentaryTypes } from '@/constants/common'
import { orientation } from '@/constants/focus'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'

import {
  AccentText,
  ContentUnavailableWrapper,
  MatchCommentaryGroup,
} from '../styles'
import { formatDateForCommentaryRequest } from '../utils'
import { MatchCommentary } from './MatchCommentary'

export const MatchCommentaryContent: FC<MatchCommentaryContentProps> = ({
  matches,
  activeMatch,
  onArrowHandler,
  // commentaryType,
}) => {
  const { t } = useCommonTranslation()
  const controller = useRef<Nullable<AbortController>>()

  const [isCommentaryLoading, setCommentaryLoading] = useState(true)
  const [commentaryData, setCommentaryData] =
    useState<Nullable<CommentaryData>>(null)

  useEffect(() => {
    if (!matches.length) {
      setCommentaryData(null)
    }
  }, [matches])

  useEffect(() => {
    if (!activeMatch) {
      return
    }

    setCommentaryData(null)
    updateCommentary()
    if (activeMatch.matchStatus !== MatchStatus.Playing) {
      return
    }
    const intervalId = window.setInterval(
      updateCommentary,
      REQUEST_COMMENTARY_INTERVAL,
    )
    return () => {
      controller.current?.abort()
      clearInterval(intervalId)
    }
  }, [activeMatch?.id, activeMatch?.matchStatus])

  const updateCommentary = () => {
    if (!activeMatch) {
      return
    }
    controller.current?.abort()
    controller.current = new AbortController()

    void getCommentary(
      activeMatch.id,
      setCommentaryLoading,
      setCommentaryData,
      commentaryTypes.MANUAL,
      controller.current,
    )
  }

  if (!matches.length) {
    return null
  }
  if (commentaryData?.message?.length || isCommentaryLoading) {
    const messages = commentaryData?.message

    return (
      <MatchCommentaryGroup
        orientation={orientation.VERTICAL}
        onArrow={onArrowHandler}
      >
        <div>
          {commentaryData && messages?.length ? (
            messages.map((message) => (
              <MatchCommentary
                key={message.id}
                commentaryData={commentaryData}
                message={message}
              />
            ))
          ) : (
            <Loader />
          )}
        </div>
      </MatchCommentaryGroup>
    )
  }

  const startsAt = activeMatch?.startsAt
  const startTime = startsAt && new Date(startsAt)
  let contentUnavailable = t('dataWidget.commentary.noCommenteryData')
  let formattedStartTime
  if (startTime && isFuture(startTime)) {
    contentUnavailable = t('dataWidget.commentary.matchStarts')
    formattedStartTime = formatDateForCommentaryRequest(startTime)
  }
  return (
    <ContentUnavailableWrapper>
      <ContentUnavailable>
        {contentUnavailable}
        {formattedStartTime && <AccentText>{formattedStartTime}</AccentText>}
      </ContentUnavailable>
    </ContentUnavailableWrapper>
  )
}
